/** @jsxImportSource @emotion/react */

import { Player } from '@lottiefiles/react-lottie-player';
import {isMobile} from 'react-device-detect';
import { containerStyles, transitionContainerStyles } from './utils-loader.module.style';

export function PageLoader() {
  return (
    <div css={containerStyles}>
      <Player
        autoplay
        loop
        src={require('./utils-loader.json')}
        style={{ 
          height: isMobile ? '100px' : '100px', 
          width: isMobile ? '100px' : '100px' 
        }}>
      </Player>
    </div>
  );
}

export function TransitionLoader() {
  return (
    <div css={transitionContainerStyles}>
      <Player
        autoplay
        loop
        src={require('./utils-loader.json')}
        style={{ 
          height: isMobile ? '100px' : '100px', 
          width: isMobile ? '100px' : '100px' 
        }}>
      </Player>
    </div>
  );
}
